import { inject, Injectable } from '@angular/core';
import { DropdownOption, Lead } from './leads-state/leads.models';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class LeadsService {
  private _apiUrl = environment.apiUrl;
  private _httpClient = inject(HttpClient);

  constructor() { }

  getLeads(leadType: string): Observable<Lead[]> {
    return this._httpClient.get<Lead[]>(`${this._apiUrl}/v1/leads/get-all-leads/${leadType}`);
  }

  createLead(lead: Lead): Observable<Lead> {
    return this._httpClient.post<Lead>(`${this._apiUrl}/v1/leads/create-lead`, lead);
  }

  deleteLead(id: string): Observable<Lead> {
    return this._httpClient.delete<Lead>(`${this._apiUrl}/v1/leads/delete-lead/${id}`);
  }

  updateLead(lead: Lead, md5Checksum: string): Observable<Lead> {
    return this._httpClient.put<Lead>(`${this._apiUrl}/v1/leads/update-lead/${lead._id}/${md5Checksum}`, lead);
  }

  getTobaccoTypes(): Observable<DropdownOption[]> {
    return this._httpClient.get<DropdownOption[]>(
      `${this._apiUrl}/v1/dropdown-options/get-by-type?type=tobaccoType`
    );
  }

  getTobaccoForms(): Observable<DropdownOption[]> {
    return this._httpClient.get<DropdownOption[]>(
      `${this._apiUrl}/v1/dropdown-options/get-by-type?type=tobaccoForm`
    );
  }

  //** Leads Status Functions */

  getDropdownsFilter(payload) {
    return this._httpClient.post(`${this._apiUrl}/v1/dropdown-options/get-dropdowns-filter`, payload);
  }

  updateLeadStatus(_id: string, status: string) {
    return this._httpClient.put(`${this._apiUrl}/v1/leads/update-lead-status/${_id}`, status);
  }
}
